/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_MY_COMMITTE_INVITE_STATUS } from "../graphql";
import { VApplication } from "../../../application";
import config from "../config/inviteTable.config.json";
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IInviteTableMethods extends IPluginMethodMap {
  getInviteTableProps(args: any): Promise<any>;
}

export class InviteTableService implements IAgentPlugin {
  readonly methods: IInviteTableMethods;

  constructor() {
    this.methods = {
      getInviteTableProps: this.getInviteTableProps.bind(this),
    };
  }

  async getInviteTableProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: GET_MY_COMMITTE_INVITE_STATUS,
          fetchPolicy: "network-only",
        });

        if (res?.data) {
          let payload = res?.data?.getMyCommitteInviteStatus?.content;
          const rowResult = this.getFormat(payload);
          return {
            ...config,
            ultInviteUsers: rowResult,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private getFormat(payload: any) {
    let rows: any[] = [];
    let i = 0;
    payload.forEach((item: any) => {
      let not_purchased = (item?.referalsUsed ?? 0) - (item?.purchased ?? 0);
      let rem = (item?.maxInvites ?? 0) - (item?.referalsUsed ?? 0);
      if (item?.inviteType !== "Discount" && item?.presentation?.id) {
        rows.push({
          key: i++,
          presentation: item?.presentation?.name,
          presentationId: item?.presentation?.id,
          sections: item?.sections !== null ? item?.sections?.name : "-",
          sectionsId: item?.sections !== null ? item?.sections?.id : "",
          partition: item?.partition !== null ? item?.partition : "-",
          inviteType: item?.inviteType !== null ? item?.inviteType : "-",
          sectionOptType:
            item?.sectionOptType !== null ? item?.sectionOptType : "-",
          maxInvites: item?.maxInvites ?? 0,
          invitesUsed: item?.referalsUsed ?? 0,
          purchased: item?.purchased ?? 0,
          not_purchased: not_purchased > 0 ? not_purchased : 0,
          remaining: rem > 0 ? rem : 0,
        });
      }
    });

    return rows;
  }
}
